export class Location {
    name: string;
    code: string;
    type: string;
    displayType?: string;
}
